import { render, staticRenderFns } from "./RefillProductsHead.vue?vue&type=template&id=f70d9c74"
import script from "./RefillProductsHead.vue?vue&type=script&lang=js"
export * from "./RefillProductsHead.vue?vue&type=script&lang=js"
import style0 from "./RefillProductsHead.vue?vue&type=style&index=0&id=f70d9c74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports